/**
 * Instantiate truncatable content functionality.
 */
(function () {
  const truncatableContent = document.querySelectorAll('[data-truncatable-content]');
  window.truncatable_i18n = window.truncatable_i18n || {};
  window.truncatable_i18n.showMoreButtonText = 'Show More Styles';

  /**
   * Process each element identified as truncatable.
   */
  truncatableContent.forEach(function (container) {
    const children = Array.from(container.children);
    // Array.slice will return all items that we want to hide.
    const hidden = children.slice(container.dataset.truncatableContent);

    // If there are no items to hide, do nothing.
    if (!hidden.length) return;

    hidden.forEach(function (item) {
      item.setAttribute('aria-hidden', true);
    });

    // Create a button to show more styles.
    const button = document.createElement('button');
    button.classList.add('button');
    button.classList.add('button--outlined');
    button.innerText = truncatable_i18n.showMoreButtonText + ' (' + children.length + ')';
    button.addEventListener('click', showHiddenItems);

    // Append button to the container.
    container.appendChild(button);
  });

  /**
   * Show all hidden items in a button’s container.
   */
  function showHiddenItems (event) {
    const items = this.closest('[data-truncatable-content]')
      .querySelectorAll('[aria-hidden="true"]');

    items.forEach(function (item) {
      item.removeAttribute('aria-hidden');
    });

    // Remove button from the DOM, as it is no longer necessary.
    this.remove();
  };
})();

/**
 * Instantiate functionality that switches heading title.
 */
(function () {
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('tabs-changed', updateTextOnTabChange);
  }

  /**
   * Update the text on a node.
   */
  function updateTextOnTabChange (data) {
    const texts = document.querySelectorAll('[data-change-text-with-tab]');

    texts.forEach(function (text) {
      // If the tabs instance ID doesn’t match this text, do nothing.
      if (data.id !== text.dataset.changeTextWithTab) return;

      text.innerText = data.selected.innerText;
    });
  }
})();

/**
 * Instantiate Google Map functionality.
 */
(function () {
  const container = document.getElementById('js-view-dealer-map');
  const addressElement = document.querySelector('[data-dealer-address]');

  // If there is no maps container or no address element, do nothing.
  if (!container || !addressElement) return;

  document.addEventListener('DOMContentLoaded', function () {
    const KEY_API = container.getAttribute('data-map-api-key');
    const googleMapsData = {
      address: addressElement.getAttribute('data-dealer-address'),
    };

    const elementScript = document.createElement('script');
    elementScript.src = `https://maps.googleapis.com/maps/api/js?key=${KEY_API}`;
    document.head.appendChild(elementScript);

    const options = {
      zoom: 18,
      center: {
        lat: -34.397,
        lng: 150.644
      },
      disableDefaultUI: true,
      styles: [
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'off',
            }
          ]
        },
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            }
          ]
        },
        {
          featureType: 'transit',
          stylers: [
            {
              visibility: 'off',
            }
          ]
        },
      ]
    };

    elementScript.addEventListener('load', function () {
      const findDealerByAddress = new google.maps.Geocoder();
      const map = new google.maps.Map(container, options);
      const icon = container.getAttribute('data-map-marker-icon-url');

      findDealerByAddress.geocode(googleMapsData, function (results, status) {
        if (status === 'OK') {
          map.setCenter(results[0].geometry.location);
          new google.maps.Marker({
            map: map,
            icon: icon,
            position: results[0].geometry.location,
          });
        }
      });
    });
  });
})();
